// Default roomscene for print page
const DEFAULT_PRINT_ROOMSCENE = {
    sortOrder: 0,
    productId: 6122342,
    displayName: "",
    description: "Hospitality",
    category2: "",
    category1: "",
    defaultSel: "",
    productCategory: "Commercial Interior",
    specifier: "Mannington\\Custom_Rug\\Images\\Hospitality_Overhead",
    name: "Hospitality"
};

// Texture type labels (same as CustomizeColors)
const TEXTURE_TYPES = {
    'L': 'Loop',
    'C': 'Cut',
    'CL': 'Cut\\Loop',
    'B': 'Background'
};

/**
 * Generate print page URL with all pattern data as query parameters
 * Uses displayColors (sorted/deduped) for the color swatches
 */
export function generatePrintUrl(chosenPattern, patternColors, displayColors, selectedRoomscene, selectedFloorProduct, size) {
    if (!chosenPattern || !patternColors || patternColors.length === 0) return null;

    const params = new URLSearchParams();

    // Pattern info
    params.set('patternId', chosenPattern.id);
    params.set('patternName', chosenPattern.name || '');
    params.set('patternSku', chosenPattern.sku || '');
    params.set('patternDescriptor', chosenPattern.descriptor || '');
    params.set('patternStyle', chosenPattern.style || '');
    params.set('patternSpecifier', chosenPattern.specifier || '');
    params.set('defaultRoomSceneSpecifier', chosenPattern.defaultRoomSceneSpecifier || '');

    // Color IDs (use patternColors for image rendering - needs original order)
    const colorIds = patternColors.map(c => c.currentId).join(',');
    params.set('colors', colorIds);

    // Display colors data (sorted/deduped for swatches)
    const colorsToDisplay = displayColors && displayColors.length > 0 ? displayColors : patternColors;
    
    // Display color IDs
    const displayColorIds = colorsToDisplay.map(c => c.currentId).join(',');
    params.set('displayColorIds', displayColorIds);

    // Display color SKUs
    const displayColorSkus = colorsToDisplay.map(c => c.sku || `#${c.currentId}`).join(',');
    params.set('displayColorSkus', displayColorSkus);

    // Display color RGBs (from product specifier if available)
    const displayColorRgbs = colorsToDisplay.map(c => {
        if (c.product?.specifier) {
            const match = c.product.specifier.match(/RGB\((\d+),(\d+),(\d+)\)/i);
            if (match) {
                return `${match[1]},${match[2]},${match[3]}`;
            }
        }
        // Default gray if no RGB found
        return '180,180,180';
    }).join('|');
    params.set('displayColorRgbs', displayColorRgbs);

    // Display color texture labels (Cut, Loop, Cut\Loop, Background)
    const displayColorTextures = colorsToDisplay.map(c => {
        const textureCode = c.textureCode || '';
        return TEXTURE_TYPES[textureCode] || textureCode || '';
    }).join(',');
    params.set('displayColorTextures', displayColorTextures);

    // Room scene - use default if none selected
    const roomscene = selectedRoomscene || DEFAULT_PRINT_ROOMSCENE;
    params.set('roomSpecifier', roomscene.specifier);

    // Floor product
    if (selectedFloorProduct?.specifier) {
        params.set('floorSpecifier', selectedFloorProduct.specifier);
    }

    // Size
    if (size) {
        params.set('size', size);
    }

    return `/print.html?${params.toString()}`;
}

/**
 * Open print page in new window
 */
export function openPrintPage(chosenPattern, patternColors, displayColors, selectedRoomscene, selectedFloorProduct, size) {
    const url = generatePrintUrl(chosenPattern, patternColors, displayColors, selectedRoomscene, selectedFloorProduct, size);
    if (url) {
        window.open(url, '_blank');
    }
}
